import { render, staticRenderFns } from "./SuccessfulPayment.vue?vue&type=template&id=6e12fd98"
import script from "./SuccessfulPayment.vue?vue&type=script&lang=js"
export * from "./SuccessfulPayment.vue?vue&type=script&lang=js"
import style0 from "./SuccessfulPayment.vue?vue&type=style&index=0&id=6e12fd98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports